function setRouterParams(params) {
  const searchData = new URLSearchParams()
  for (const param in params) {
    searchData.append(param, params[param])
  }
  window.history.replaceState({}, null, '?' + searchData.toString())
}
function getRouterParams() {
  const params = new URLSearchParams(window.location.search)
  return Object.fromEntries(params.entries())
}

export { setRouterParams, getRouterParams }
